import { Select, Spin, Tooltip } from "antd";
import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { FilterIcon, SelectionIcon } from "../../assets/svg";
import { FilterFilledIcon } from "../../assets/svg-components/filter-apply-icon";
import { SearchIconSvg } from "../../components/search-icon";
import { Config } from "../../config";
import { APIStatus, SessionStorageKeys } from "../../constants";
import { QueTypeAndWeightage } from "../../modal/college";
import { PaginationWithNumber } from "../../modal/common";
import { useAppDispatch, useAppSelector } from "../../modal/hooks";
import { Filter } from "../../modal/result";
import { Table } from "../../plugins/table";
import { bulkSelectionAction, getAllResults } from "../../services/results/results.service";
import { clearAllResults, clearBulkSelectionActionChange } from "../../services/results/results.slice";
import { resetPage } from "../../services/table-plugin/table-plugin.slice";
import { showSuccess } from "../../utils/util.fns";
import { columns } from "./columns";
import { FilterComponent } from "./filter";
import "./results.scss";
import ReScheduleModal from "./modal";

const currentYear = new Date().getFullYear().toString();
let QueryFilter = "";
export interface FilterType {
	search: string;
	questionType: QueTypeAndWeightage[];
	examStatus: string;
	answerStatus?: boolean | null;
	thresHold: string;
	year: string;
	college: number | null;
	department: string;
	gender: string;
	isClickFilter: boolean;
	cgpa: string;
	backlog: string;
}

export const ResultList: React.FunctionComponent = () => {
	const resultsFromRedux = useAppSelector((store) => store.results);
	// const resultsw = resultsFromRedux.result.slice().sort((a, b) => (b.score ?? -Infinity) - (a.score ?? -Infinity));

	const results = useMemo(() => {
		return resultsFromRedux.result.slice().sort((a, b) => (b.score ?? -Infinity) - (a.score ?? -Infinity));
	}, [resultsFromRedux.result]);

	const selectedDataAPI = useMemo(
		() =>
			results
				.filter((item: any) => item.selected !== null)
				.map((item: any) => ({
					id: item.id,
					status: item.selected === "SELECTED" ? true : false,
					complete: item.completed,
				})),
		[results]
	);

	const studentStatusUpdateCompleted = useAppSelector((store) => store.results.actionChangeCompleted);
	const bulkactionChangeCompleted = useAppSelector((store) => store.results.bulkactionChangeCompleted);
	const dispatch = useAppDispatch();
	const [filterLoading, setFilterLoading] = useState<boolean>(false);
	const [isFirstLoad, setIsFirstLoad] = useState<boolean>(true);
	const [filter, setFilter] = useState<Filter>({
		department: null,
		gender: null,
		search: "",
		college: null,
		status: null,
		completed: null,
		year: currentYear,
		backlog: null,
		cgpa: null,
	});
	const resultLoading = useAppSelector((store) => store.results.resultLoading);
	const submittedCount = useAppSelector((store) => store.results.totalCount);
	const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
	const [filterData, setFilterData] = useState<FilterType>({
		search: "",
		questionType: [],
		examStatus: "",
		answerStatus: null,
		thresHold: "",
		year: currentYear,
		college: null,
		department: "",
		gender: "",
		isClickFilter: false,
		backlog: "",
		cgpa: "",
	});
	const [appliedFiltersCount, setAppliedFiltersCount] = useState<number>(0);
	const [rescheduleModal, setRescheduleModal] = useState<{ isOpen: boolean; data: any }>({
		isOpen: false,
		data: null,
	});
	const [appliedFiltersItem, setAppliedFilterItem] = useState<string[]>([]);
	const [selectStudent, setSelectStudent] =
		useState<{ id: number; status: boolean; complete: boolean }[]>(selectedDataAPI);

	useEffect(() => {
		if (bulkactionChangeCompleted === APIStatus.FULFILLED) {
			dispatch(clearBulkSelectionActionChange());
			showSuccess("Selection updated successfully");
			dispatch(resetPage());
		}
		if (bulkactionChangeCompleted === APIStatus.REJECTED) {
			dispatch(clearBulkSelectionActionChange());
		}
	}, [bulkactionChangeCompleted]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (!isFirstLoad) {
				dispatch(resetPage());
			}
		}, 1000);
		return () => {
			clearTimeout(timeout);
		};
	}, [filterData]);

	useEffect(() => {
		setSelectStudent(selectedDataAPI);
	}, [results]);

	useEffect(() => {
		setAppliedFiltersCount(getActiveFilterCount());
	}, [filterData]);

	const downloadClicked = (downloadAll?: boolean) => {
		let queryAll = `${filter.department ? `&department=${filter.department}` : ""}`;
		queryAll += `${filter.gender ? `&gender=${filter.gender}` : ""}`;
		queryAll += `${filter.search ? `&search=${filter.search}` : ""}`;
		queryAll += `${filter.status ? `&status=${filter.status}` : ""}`;
		queryAll += `${filter.completed != null ? `&completed=${filter.completed}` : ""}`;
		queryAll += `${filter.college != null ? `&collegeId=${filter.college}` : ""}`;
		queryAll += `${filter.year != null ? `&year=${filter.year}` : ""}`;
		queryAll += `${filter.cgpa != null ? `&cgpa=${filter.cgpa}` : ""}`;
		queryAll += `${filter.backlog != null ? `&backlogs=${filter.backlog}` : ""}`;
		const exportExcel = downloadAll ? queryAll : QueryFilter;
		axios({
			url: `${Config.apiSecureUrl}/result/excel?${exportExcel}`,
			method: "GET",
			responseType: "blob",
			headers: {
				Authorization: `Bearer ${sessionStorage.getItem(SessionStorageKeys.TOKEN)}`,
			},
		}).then((response) => {
			const blob = new Blob([response.data], { type: "text/xls" });
			const windowUrl = window.URL || window.webkitURL;
			const url = windowUrl.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.download = "exam_result.xlsx";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		});
	};

	const searchChanged = (search: string) => {
		setFilter((prevState) => ({ ...prevState, search: search }));
	};

	const onView = (e: number) => {
		// alert("Comming soon...");
		// navigate(`/result/review/${e}`);
	};

	const exportOptions = [
		{ value: "All", label: "Export All" },
		{ value: "Export Excel", label: "Export Excel" },
	];

	const handleFilterOpen = () => {
		setIsFilterOpen(!isFilterOpen);
	};

	const handleUnClickAdvanceFilter = () => {
		setAppliedFiltersCount(getActiveFilterCount());
		setIsFilterOpen(!isFilterOpen);
	};

	const getActiveFilterCount = () => {
		let count = 0;
		const appliedFilters: string[] = [];

		const { questionType, examStatus, answerStatus, thresHold, year, college, department, cgpa, backlog } = filterData;

		if (questionType && questionType.length > 0) {
			count++;
			appliedFilters.push("Question");
		}
		if (answerStatus) {
			count++;
			appliedFilters.push("Answer");
		}
		if (thresHold && thresHold.length > 0) {
			count++;
			appliedFilters.push("Threshold");
		}
		if (year && year.length > 0) {
			count++;
			appliedFilters.push("Year");
		}
		if (college) {
			count++;
			appliedFilters.push("College");
		}
		if (department && department.length > 0) {
			count++;
			appliedFilters.push("Department");
		}
		if (examStatus) {
			count++;
			appliedFilters.push("Exam Status");
		}
		if (cgpa && cgpa.length > 0) {
			count++;
			appliedFilters.push("Cgpa");
		}
		if (backlog && backlog.length > 0) {
			count++;
			appliedFilters.push("Cgpa");
		}
		setAppliedFilterItem(appliedFilters);
		return count;
	};

	const handleFilterChange = (key: keyof FilterType, value: any) => {
		setFilterData((prevData) => {
			if (key === "questionType") {
				const updatedQuestionTypes = prevData.questionType.includes(value)
					? prevData.questionType.filter((item) => item !== value)
					: [...prevData.questionType, value];

				return { ...prevData, questionType: updatedQuestionTypes };
			}

			if (key === "examStatus") {
				return { ...prevData, [key]: prevData[key] === value ? "" : value };
			}

			if (key === "answerStatus") {
				return { ...prevData, [key]: prevData[key] === value ? "" : value };
			}

			return { ...prevData, [key]: value };
		});
	};

	const handleClearAll = () => {
		setFilterData((preState) => {
			return {
				...preState,
				search: "",
				questionType: [],
				examStatus: "",
				answerStatus: null,
				thresHold: "",
				year: currentYear,
				college: null,
				department: "",
				gender: "",
				isClickFilter: false,
				backlog: "",
				cgpa: "",
			};
		});
	};

	const handleExportChange = (selectedOption: any) => {
		console.log(selectedOption, "selected Option");
		if (selectedOption === "All") {
			downloadClicked(true);
		} else {
			downloadClicked(false);
		}
	};

	const handleSearchByName = (event: React.ChangeEvent<HTMLInputElement>) => {
		setFilterData((prevState) => {
			return { ...prevState, search: event.target.value };
		});
	};

	const handleSelectStudent = (id: number, event: any): [] => {
		setSelectStudent((prevState) => {
			if (!prevState) return [];
			return prevState.map((item) => (item.id === id ? { ...item, status: event.target.checked } : item));
		});

		return [];
	};

	const handleSelectAll = (selectall: boolean) => {
		setSelectStudent((prevState) => {
			if (!prevState) return [];

			return (
				prevState
					// .filter((item: any) => item.complete === true)
					.map((item) => ({ ...item, status: item.complete ? selectall : false }))
			);
		});
	};
	const handleSelectionAPI = () => {
		const reqBody = selectStudent.map((item) => ({
			studentId: item.id,
			selectionStatus: item.status,
		}));
		dispatch(bulkSelectionAction(reqBody));
	};

	const handleResecheduleModal = (row: any) => {
		setRescheduleModal((prestate) => ({
			...prestate,
			isOpen: true,
			data: row,
		}));
	};

	console.log(rescheduleModal, "rescheduleModal");

	return (
		<div className="overview_content_box result_listing_main_container d-flex overview-content-container px-4">
			<div className={`left-container ${isFilterOpen ? "expanded" : "full-width"}`}>
				<div className="filter-main-container d-flex justify-content-between px-1">
					<div className="overview_tool_box custom_main_form filter_container min_width_300 max_width_300 d-flex align-items-center justify-content-end">
						<div className="custom_input_field_container flex_1_1_10 position-relative">
							<input
								type="text"
								className="custom_input_field form_input padding_right_30"
								placeholder="Search"
								onChange={handleSearchByName}
								value={filterData.search}
							/>
							<SearchIconSvg className="search_icon_svg cursor_pointer" />
						</div>
					</div>
					<div className="d-flex align-items-center mb-2 pr-1" style={{ gap: "13px" }}>
						<span
							onClick={() => {
								handleFilterOpen();
							}}
						>
							{!isFilterOpen ? (
								<div
									onClick={() => {
										handleFilterOpen();
									}}
									className="filter_icon cursor_pointer position-relative px-1 d-flex align-items-center r-1"
								>
									<Tooltip title={appliedFiltersItem.join(", ")} placement="top">
										<FilterIcon width={28} height={28} color="#F15623" className="filter_icon" />
										{appliedFiltersCount > 0 && <span className="filter_icon_count">{appliedFiltersCount}</span>}
									</Tooltip>
								</div>
							) : (
								<div
									onClick={handleUnClickAdvanceFilter}
									className="filter_icon cursor_pointer px-2 d-flex align-items-center pr-1"
								>
									<FilterFilledIcon width={28} height={28} color="#F15623" className="filter_filled_icon" />
								</div>
							)}
						</span>
						{/* {selectStudent.some((item) => item.status === true) && ( */}
						<Tooltip title={"Select or deselect students"} placement="top">
							<div
								onClick={() => {
									handleSelectionAPI();
								}}
								className="tick_icon cursor_pointer position-relative pr-1 d-flex align-items-center"
							>
								<SelectionIcon width={30} height={30} color="#F15623" />
							</div>
						</Tooltip>
						{/* // )} */}
						<Select
							onChange={handleExportChange}
							className="custom-select"
							placeholder="Export All"
							options={exportOptions}
						/>
					</div>
				</div>
				<div className="custom_table_main_container">
					{filterLoading ? (
						<div className="d-flex align-items-center justify-content-center h-100">
							<Spin />
						</div>
					) : (
						<Table
							handleCheckBox={handleSelectAll}
							checkboxData={selectStudent}
							loading={resultLoading}
							totalResults={submittedCount}
							defaultSort=""
							headers={columns(onView, handleSelectStudent, handleResecheduleModal, selectStudent)}
							tableData={results}
							fetchData={(pagination: PaginationWithNumber) => {
								setIsFirstLoad(false);
								if (pagination.pageNumber === 0) {
									dispatch(clearAllResults());
								}
								let query = `offset=${pagination.pageNumber}&numResults=${pagination.numResults}`;
								query += `${filterData.department ? `&department=${filterData.department}` : ""}`;
								query += `${filterData.gender ? `&gender=${filterData.gender}` : ""}`;
								query += `${filterData.search ? `&search=${filterData.search}` : ""}`;
								query += `${filterData.examStatus ? `&status=${filterData.examStatus}` : ""}`;
								query += `${filterData.college != null ? `&collegeId=${filterData.college}` : ""}`;
								query += `${filterData.answerStatus != null ? `&completed=${filterData.answerStatus}` : ""}`;
								query += `${pagination.sort ? `&sortBy=${pagination.sort}` : "&sortBy=score"}`;
								query += `${pagination.sort ? `&desc=${pagination.desc}` : ""}`;
								query += `${filterData.year != null ? `&year=${filterData.year}` : "2025"}`;
								query += `${filterData.thresHold != null ? `&scoreThreshold=${filterData.thresHold}` : ""}`;
								query += `${filterData.cgpa != null ? `&cgpa=${filterData.cgpa}` : ""}`;
								query += `${filterData.backlog != null ? `&backlogs=${filterData.backlog}` : ""}`;
								query +=
									filterData.questionType && filterData.questionType.length > 0
										? `&type=${filterData.questionType.map((q) => q.name).join(",")}`
										: "";
								dispatch(getAllResults(query));
								QueryFilter = query;
							}}
						/>
					)}
				</div>
			</div>
			<div className="filter-component-container">
				<FilterComponent
					isFilterOpen={isFilterOpen}
					handleFilterOpen={handleFilterOpen}
					handleFilterChange={handleFilterChange}
					filterData={filterData}
					handleClearAll={handleClearAll}
				/>
			</div>
			{rescheduleModal.isOpen && (
				<ReScheduleModal
					handleCancel={() => {
						setRescheduleModal((prestate) => ({ ...prestate, isOpen: false }));
					}}
					propsData={rescheduleModal}
				/>
			)}
		</div>
	);
};
